export enum BuildRuntime {
    Node180 = 'node-18.0',
    Node200 = 'node-20.0',
    Node22 = 'node-22',
    Node23 = 'node-23',
    Node24 = 'node-24',
    Node25 = 'node-25',
    Php81 = 'php-8.1',
    Php82 = 'php-8.2',
    Php83 = 'php-8.3',
    Php84 = 'php-8.4',
    Ruby31 = 'ruby-3.1',
    Ruby32 = 'ruby-3.2',
    Ruby33 = 'ruby-3.3',
    Ruby34 = 'ruby-3.4',
    Ruby40 = 'ruby-4.0',
    Python39 = 'python-3.9',
    Python310 = 'python-3.10',
    Python311 = 'python-3.11',
    Python312 = 'python-3.12',
    Python313 = 'python-3.13',
    Python314 = 'python-3.14',
    Pythonml311 = 'python-ml-3.11',
    Pythonml312 = 'python-ml-3.12',
    Pythonml313 = 'python-ml-3.13',
    Deno146 = 'deno-1.46',
    Deno20 = 'deno-2.0',
    Deno25 = 'deno-2.5',
    Deno26 = 'deno-2.6',
    Dart218 = 'dart-2.18',
    Dart219 = 'dart-2.19',
    Dart30 = 'dart-3.0',
    Dart31 = 'dart-3.1',
    Dart33 = 'dart-3.3',
    Dart35 = 'dart-3.5',
    Dart38 = 'dart-3.8',
    Dart39 = 'dart-3.9',
    Dart310 = 'dart-3.10',
    Dotnet80 = 'dotnet-8.0',
    Dotnet10 = 'dotnet-10',
    Java80 = 'java-8.0',
    Java110 = 'java-11.0',
    Java170 = 'java-17.0',
    Java210 = 'java-21.0',
    Java22 = 'java-22',
    Java25 = 'java-25',
    Swift58 = 'swift-5.8',
    Swift59 = 'swift-5.9',
    Swift510 = 'swift-5.10',
    Swift62 = 'swift-6.2',
    Kotlin18 = 'kotlin-1.8',
    Kotlin19 = 'kotlin-1.9',
    Kotlin20 = 'kotlin-2.0',
    Kotlin23 = 'kotlin-2.3',
    Cpp17 = 'cpp-17',
    Cpp20 = 'cpp-20',
    Cpp23 = 'cpp-23',
    Bun10 = 'bun-1.0',
    Bun11 = 'bun-1.1',
    Bun12 = 'bun-1.2',
    Bun13 = 'bun-1.3',
    Go123 = 'go-1.23',
    Go124 = 'go-1.24',
    Go125 = 'go-1.25',
    Go126 = 'go-1.26',
    Static1 = 'static-1',
    Flutter324 = 'flutter-3.24',
    Flutter327 = 'flutter-3.27',
    Flutter329 = 'flutter-3.29',
    Flutter332 = 'flutter-3.32',
    Flutter335 = 'flutter-3.35',
    Flutter338 = 'flutter-3.38',
}